var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};

// src/components/Accordion.tsx
import * as React2 from "react";
import {
  Accordion as AccordionContext,
  AccordionItem as AccordionItemWrapper,
  AccordionButton,
  AccordionPanel,
  useAccordionItemContext
} from "@reach/accordion";
import cx2 from "classnames";

// src/components/Typography.tsx
import * as React from "react";
import cx from "classnames";
var variants = {
  Body: "text-sm font-normal",
  HeadingMedium: "text-xl font-semibold",
  HeadingSmall: "text-base font-semibold",
  Subheading: "text-xs font-semibold uppercase",
  DisplayXLarge: "text-4xl font-bold",
  DisplayLarge: "text-3xl font-semibold",
  DisplayMedium: "text-2xl font-normal",
  DisplaySmall: "text-xl font-normal",
  Caption: "text-xs font-normal",
  Link: "text-url font-normal",
  Button: "text-base font-bold",
  ButtonLink: "text-xs font-bold uppercase"
};
var Typography = (_a) => {
  var _b = _a, {
    variant = "Body",
    children,
    className,
    component: Component = "span"
  } = _b, props = __objRest(_b, [
    "variant",
    "children",
    "className",
    "component"
  ]);
  return /* @__PURE__ */ React.createElement(Component, __spreadValues({
    className: cx(variants[variant], className)
  }, props), children);
};
Typography.displayName = "Typography";

// src/components/Accordion.tsx
import { ChevronDown } from "@lunchboxinc/icons";
var AccordionItem = ({
  title,
  content,
  headingLevel,
  isControlled,
  readOnly
}) => {
  const { isExpanded } = useAccordionItemContext();
  return /* @__PURE__ */ React2.createElement(React2.Fragment, null, /* @__PURE__ */ React2.createElement(Typography, {
    variant: "HeadingSmall",
    component: headingLevel
  }, /* @__PURE__ */ React2.createElement(AccordionButton, {
    "aria-disabled": readOnly || isExpanded && isControlled,
    className: cx2("flex items-center gap-4 w-full p-6 focus-visible:ring-4", {
      "hover:bg-neutral-100": !readOnly,
      "cursor-not-allowed": readOnly
    })
  }, /* @__PURE__ */ React2.createElement("div", {
    className: "flex-1 text-left"
  }, title), /* @__PURE__ */ React2.createElement(ChevronDown, {
    fill: "currentColor",
    className: cx2("w-4 h-4 transform", readOnly ? "text-neutral-500" : "text-url", {
      "rotate-180": isExpanded
    }),
    "aria-hidden": true,
    focusable: false
  }))), /* @__PURE__ */ React2.createElement(AccordionPanel, {
    className: "p-6 border-t border-inherit"
  }, content));
};
var Accordion = (_a) => {
  var _b = _a, { items, headingLevel, readOnly } = _b, props = __objRest(_b, ["items", "headingLevel", "readOnly"]);
  const isControlled = "index" in props;
  const accordionProps = __spreadValues(__spreadValues({}, props), !isControlled ? { collapsible: true } : {});
  return /* @__PURE__ */ React2.createElement(AccordionContext, __spreadProps(__spreadValues({}, accordionProps), {
    readOnly
  }), items.map((item) => {
    const itemProps = __spreadProps(__spreadValues({}, item), {
      headingLevel,
      isControlled,
      readOnly
    });
    return /* @__PURE__ */ React2.createElement(AccordionItemWrapper, {
      key: item.id,
      className: "border border-b-0 border-neutral-200 last:border-b first:rounded-t-md last:rounded-b-md"
    }, /* @__PURE__ */ React2.createElement(AccordionItem, __spreadValues({}, itemProps)));
  }));
};
Accordion.displayName = "Accordion";

// src/components/Alert.tsx
import * as React4 from "react";
import cx4 from "classnames";
import { Alert as ReachAlert } from "@reach/alert";
import { Times } from "@lunchboxinc/icons";

// src/components/Button.tsx
import * as React3 from "react";
import cx3 from "classnames";
import { useGarnish } from "@lunchboxinc/garnish";
var baseStyles = "flex place-items-center gap-2 border";
var variants2 = {
  primary: "hover:bg-opacity-80 cursor-pointer rounded-md",
  secondary: "bg-powder text-bob border-neutral-500 cursor-pointer hover:bg-neutral-100 rounded-md",
  tertiary: "bg-transparent text-teal-800 border-transparent hover:text-teal-600 cursor-pointer",
  ghost: "bg-transparent"
};
var sizes = {
  small: "px-2 py-1",
  medium: "px-3 py-2",
  large: "px-4 py-3"
};
var baseDisabledStyles = "border-transparent cursor-not-allowed";
var disabledStyles = `${baseDisabledStyles} bg-gray-200 text-neutral-700 rounded-md`;
var tertiaryDisabledStyles = `${baseDisabledStyles} bg-transparent text-neutral-600`;
var buttonStyles = ({
  variant,
  size,
  disabled,
  className
}) => {
  return cx3(baseStyles, {
    [variants2[variant]]: !disabled,
    [sizes[size]]: variant !== "ghost",
    [disabledStyles]: disabled && (variant === "primary" || variant === "secondary"),
    [tertiaryDisabledStyles]: disabled && variant === "tertiary"
  }, className);
};
var defaultTheme = {
  text: "text-bob",
  background: "bg-yellow-brand",
  border: "border-yellow-700"
};
var useTheme = ({ variant, disabled }) => {
  const theme = useGarnish(defaultTheme);
  return React3.useMemo(() => {
    const classes = Object.values(theme).join(" ");
    return { [classes]: !disabled && variant === "primary" };
  }, [theme]);
};
var Button = (_a) => {
  var _b = _a, {
    children,
    onClick,
    type = "button",
    variant = "primary",
    size = "medium",
    icon,
    disabled
  } = _b, props = __objRest(_b, [
    "children",
    "onClick",
    "type",
    "variant",
    "size",
    "icon",
    "disabled"
  ]);
  const themeStyles = useTheme({ disabled, variant });
  const handleClick = (e) => disabled ? e.preventDefault() : onClick == null ? void 0 : onClick(e);
  const typographyVariant = variant === "tertiary" || variant === "ghost" ? "Body" : "Button";
  return /* @__PURE__ */ React3.createElement("button", __spreadProps(__spreadValues({}, props), {
    type,
    onClick: handleClick,
    className: buttonStyles({
      variant,
      size,
      disabled,
      className: cx3(themeStyles, props.className)
    }),
    "aria-disabled": disabled
  }), icon, /* @__PURE__ */ React3.createElement(Typography, {
    variant: typographyVariant,
    className: "whitespace-nowrap"
  }, children));
};
Button.displayName = "Button";
var IconButton = (_a) => {
  var _b = _a, {
    icon,
    children,
    onClick,
    type = "button",
    variant = "primary",
    size = "medium",
    disabled
  } = _b, props = __objRest(_b, [
    "icon",
    "children",
    "onClick",
    "type",
    "variant",
    "size",
    "disabled"
  ]);
  const themeStyles = useTheme({ disabled, variant });
  const handleClick = (e) => disabled ? e.preventDefault() : onClick == null ? void 0 : onClick(e);
  const content = icon || children;
  return /* @__PURE__ */ React3.createElement("button", __spreadProps(__spreadValues({}, props), {
    type,
    onClick: handleClick,
    className: buttonStyles({
      variant,
      size,
      disabled,
      className: cx3(themeStyles, props.className)
    }),
    "aria-disabled": disabled
  }), content);
};
IconButton.displayName = "IconButton";

// src/components/Alert.tsx
var fillColors = {
  error: "border-red-600 bg-red-100",
  information: "border-yellow-700 bg-yellow-50",
  success: "border-teal-500 bg-teal-50"
};
var Alert = (_a) => {
  var _b = _a, {
    autoDismiss,
    children,
    onDismiss,
    variant = "information"
  } = _b, props = __objRest(_b, [
    "autoDismiss",
    "children",
    "onDismiss",
    "variant"
  ]);
  return /* @__PURE__ */ React4.createElement(ReachAlert, __spreadValues({
    className: cx4("absolute flex flex-row font-normal left-1/2 text-base normal-case whitespace-normal p-2 max-w-sm rounded-md border-solid border-2 z-[999999]", fillColors[variant])
  }, props), /* @__PURE__ */ React4.createElement("div", {
    className: "flex-wrap"
  }, children), !autoDismiss && /* @__PURE__ */ React4.createElement("div", {
    className: "flex-wrap"
  }, /* @__PURE__ */ React4.createElement(IconButton, {
    "aria-label": "place-items-start",
    icon: /* @__PURE__ */ React4.createElement(Times, {
      className: "w-5 h-5 pl-3"
    }),
    onClick: onDismiss,
    size: "small",
    style: { padding: 0 },
    variant: "tertiary"
  })));
};
Alert.displayName = "Alert";

// src/components/Breadcrumb.tsx
import * as React5 from "react";
var BreadcrumbItem = ({
  currentPage,
  page,
  linkComponent = {
    Component: "a",
    hrefPropName: "href"
  }
}) => {
  const { Component, hrefPropName } = linkComponent;
  const linkProps = {
    [hrefPropName]: page.route
  };
  const BreadcrumbLink = () => {
    return /* @__PURE__ */ React5.createElement(Component, __spreadValues({}, linkProps), page.name);
  };
  if (currentPage) {
    return /* @__PURE__ */ React5.createElement(Typography, {
      className: "text-neutral-900",
      "aria-current": "page"
    }, page.name);
  }
  return /* @__PURE__ */ React5.createElement(React5.Fragment, null, /* @__PURE__ */ React5.createElement(Typography, {
    className: "text-neutral-500"
  }, BreadcrumbLink()), /* @__PURE__ */ React5.createElement(Typography, {
    className: "text-neutral-700 mx-2"
  }, "/"));
};
var Breadcrumb = ({
  pages,
  linkComponent = {
    Component: "a",
    hrefPropName: "href"
  }
}) => {
  if (!(pages == null ? void 0 : pages.length))
    return null;
  return /* @__PURE__ */ React5.createElement("nav", {
    "aria-label": "Breadcrumbs"
  }, /* @__PURE__ */ React5.createElement("ol", {
    className: "flex"
  }, pages.map((page, i, { length }) => {
    return /* @__PURE__ */ React5.createElement("li", {
      key: `nav.${i}`
    }, /* @__PURE__ */ React5.createElement(BreadcrumbItem, {
      currentPage: length - 1 === i,
      page,
      linkComponent
    }));
  })));
};
Breadcrumb.displayName = "Breadcrumb";

// src/components/ButtonGroup.tsx
import * as React6 from "react";
import cx5 from "classnames";
var sizes2 = {
  small: "py-1 px-2",
  medium: "py-2 px-4",
  large: "py-3 px-4"
};
var ButtonGroup = (_a) => {
  var _b = _a, {
    options,
    onChange,
    defaultValue,
    size = "medium"
  } = _b, props = __objRest(_b, [
    "options",
    "onChange",
    "defaultValue",
    "size"
  ]);
  const buttonRefs = React6.useRef(options.map(() => React6.createRef()));
  const [selectedIndex, setSelectedIndex] = React6.useState(() => {
    const index = options.findIndex((option) => option.value === defaultValue);
    return index === -1 ? 0 : index;
  });
  const handleKeyPress = React6.useCallback((e) => {
    const optionCount = options.length;
    const goNext = e.code === "ArrowDown" || e.code === "ArrowRight";
    const goBack = e.code === "ArrowUp" || e.code === "ArrowLeft";
    setSelectedIndex((currentIndex) => {
      const newIndex = goNext ? currentIndex + 1 : goBack ? currentIndex - 1 : currentIndex;
      if (newIndex < 0)
        return optionCount - 1;
      else if (newIndex >= optionCount)
        return 0;
      return newIndex;
    });
  }, []);
  const initialized = React6.useRef(false);
  React6.useEffect(() => {
    if (!initialized.current) {
      initialized.current = true;
      return;
    }
    const selectedButton = buttonRefs.current[selectedIndex].current;
    selectedButton == null ? void 0 : selectedButton.focus();
    onChange(options[selectedIndex].value);
  }, [selectedIndex, onChange, options]);
  return /* @__PURE__ */ React6.createElement("div", {
    role: "radiogroup",
    "aria-labelledby": props["aria-labelledby"],
    onKeyDown: handleKeyPress,
    className: "inline-flex"
  }, options.map(({ value, label = value }, index) => {
    const ref = buttonRefs.current[index];
    const active = index === selectedIndex;
    return /* @__PURE__ */ React6.createElement("button", {
      key: value,
      ref,
      type: "button",
      role: "radio",
      "aria-checked": active,
      tabIndex: active ? 0 : -1,
      onClick: () => setSelectedIndex(index),
      className: cx5(sizes2[size], "-ml-px border border-neutral-600 first:ml-0 first:rounded-l-sm last:rounded-r-sm", "focus:z-10 focus:outline-none focus-visible:ring-1 focus-visible:ring-blue-500 focus-visible:border-blue-500", { "bg-url text-powder": active })
    }, /* @__PURE__ */ React6.createElement(Typography, null, label));
  }));
};
ButtonGroup.displayName = "ButtonGroup";

// src/components/Checkbox.tsx
import * as React7 from "react";
import { MixedCheckbox } from "@reach/checkbox";
import { iconBaseProps } from "@lunchboxinc/icons";
import cx6 from "classnames";
var Checkbox = (_a) => {
  var _b = _a, { label, checked, onChange, disabled } = _b, props = __objRest(_b, ["label", "checked", "onChange", "disabled"]);
  return /* @__PURE__ */ React7.createElement("label", {
    className: cx6("flex items-center gap-4", { "opacity-80": disabled })
  }, /* @__PURE__ */ React7.createElement(MixedCheckbox, __spreadProps(__spreadValues({}, props), {
    checked,
    onChange,
    className: "peer sr-only",
    disabled
  })), /* @__PURE__ */ React7.createElement("span", {
    className: cx6("flex place-items-center w-4 h-4 p-0.5 rounded-sm border border-solid", {
      "bg-url text-powder border-url": checked === true,
      "bg-powder text-transparent border-gray-600": checked === false,
      "bg-powder text-url border-gray-600": checked === "mixed"
    }, "peer-focus:outline-none peer-focus-visible:ring-2 peer-focus-visible:ring-offset-2 peer-focus-visible:ring-blue-500", "peer-disabled:bg-gray-100 peer-disabled:border-gray-400", { "peer-disabled:text-gray-600": checked, "cursor-not-allowed": disabled })
  }, /* @__PURE__ */ React7.createElement("svg", __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    fill: "currentColor",
    className: "w-3 h-3"
  }, iconBaseProps), checked === "mixed" ? /* @__PURE__ */ React7.createElement("rect", {
    width: "100%",
    height: "100%"
  }) : /* @__PURE__ */ React7.createElement("path", {
    d: "M435.85 83.47 172.8 346.5l-96.65-96.65a12 12 0 0 0-16.97 0L30.9 278.14a12 12 0 0 0 0 16.97l133.42 133.42a12 12 0 0 0 16.97 0l299.81-299.8a12 12 0 0 0 0-16.98l-28.28-28.28a12 12 0 0 0-16.97 0z"
  }))), /* @__PURE__ */ React7.createElement(Typography, null, label));
};
Checkbox.displayName = "Checkbox";

// src/components/ComboBox.tsx
import * as React8 from "react";
import cx7 from "classnames";
import { Combobox } from "@headlessui/react";
import { useId } from "@reach/auto-id";
import { Check, ChevronDown as ChevronDown2, iconBaseProps as iconBaseProps2 } from "@lunchboxinc/icons";
var getValue = (option, key) => typeof option === "string" ? option : option == null ? void 0 : option[key];
var ComboBox = (_a) => {
  var _b = _a, {
    label,
    labelVisible = true,
    options,
    onChange,
    placeholder
  } = _b, props = __objRest(_b, [
    "label",
    "labelVisible",
    "options",
    "onChange",
    "placeholder"
  ]);
  const id = useId(props.id);
  const [selected, setSelected] = React8.useState(props.value);
  const [query, setQuery] = React8.useState("");
  const onInputChange = (e) => {
    setQuery(e.target.value);
  };
  const onValueChange = (value) => {
    setSelected(value);
    onChange == null ? void 0 : onChange(value);
  };
  const filteredOptions = React8.useMemo(() => {
    if (query === "")
      return options;
    return options.filter((option) => {
      const label2 = getValue(option, "label");
      return new RegExp(query, "i").test(label2);
    });
  }, [options, query]);
  return /* @__PURE__ */ React8.createElement(Combobox, {
    value: selected,
    onChange: onValueChange
  }, /* @__PURE__ */ React8.createElement(Combobox.Label, {
    id,
    className: cx7({ "sr-only": !labelVisible })
  }, /* @__PURE__ */ React8.createElement(Typography, null, label)), /* @__PURE__ */ React8.createElement("div", {
    className: "relative mt-1"
  }, /* @__PURE__ */ React8.createElement(Combobox.Input, {
    className: "w-full py-2 pl-3 pr-10 rounded-md text-sm leading-5 border border-neutral-600",
    onChange: onInputChange,
    displayValue: (option) => getValue(option, "label"),
    placeholder
  }), /* @__PURE__ */ React8.createElement(Combobox.Button, {
    className: "absolute inset-y-0 right-0 flex items-center pr-2"
  }, /* @__PURE__ */ React8.createElement(ChevronDown2, __spreadProps(__spreadValues({}, iconBaseProps2), {
    className: "h-4 w-4 text-gray-400",
    "aria-hidden": "true"
  }))), /* @__PURE__ */ React8.createElement(Combobox.Options, {
    className: "absolute w-full py-1 mt-1 overflow-auto text-base bg-white rounded-md shadow-lg max-h-60 focus:outline-none sm:text-sm"
  }, filteredOptions.length === 0 ? /* @__PURE__ */ React8.createElement(Typography, {
    component: "div",
    className: "cursor-default select-none relative py-2 px-4 text-gray-700"
  }, "Option not found.") : filteredOptions.map((option) => /* @__PURE__ */ React8.createElement(Combobox.Option, {
    key: getValue(option, "value"),
    className: ({ active }) => cx7("relative cursor-default select-none py-2 pr-8 pl-3 hover:bg-gray-100 aria-disabled:cursor-not-allowed aria-disabled:opacity-50 aria-disabled:hover:bg-powder", { "bg-yellow-50": active }),
    value: option,
    disabled: typeof option === "string" ? void 0 : option.disabled
  }, ({ selected: selected2 }) => /* @__PURE__ */ React8.createElement(React8.Fragment, null, /* @__PURE__ */ React8.createElement(Typography, {
    className: "block truncate"
  }, getValue(option, "label")), /* @__PURE__ */ React8.createElement(Check, __spreadProps(__spreadValues({}, iconBaseProps2), {
    className: cx7("absolute top-1/2 right-3 transform -translate-y-1/2 flex items-center h-4 w-auto", { hidden: !selected2 })
  }))))))));
};
ComboBox.displayName = "ComboBox";

// src/components/Divider.tsx
import * as React9 from "react";
var Divider = () => {
  return /* @__PURE__ */ React9.createElement("hr", {
    className: "border border-solid bg-neutral-200 my-2.5"
  });
};
Divider.displayName = "Divider";

// src/components/Drawer.tsx
import * as React10 from "react";
import cx8 from "classnames";
import { DialogContent, DialogOverlay } from "@reach/dialog";
var sizes3 = {
  small: "sm:max-w-sm",
  medium: "sm:max-w-xl"
};
var Drawer = (_a) => {
  var _b = _a, {
    children,
    isOpen,
    onDismiss,
    "aria-labelledby": ariaLabelledBy,
    size = "medium"
  } = _b, props = __objRest(_b, [
    "children",
    "isOpen",
    "onDismiss",
    "aria-labelledby",
    "size"
  ]);
  return /* @__PURE__ */ React10.createElement(DialogOverlay, __spreadValues({
    className: "fixed inset-0 bg-neutral-900/40 z-[999999]",
    isOpen,
    onDismiss
  }, props), /* @__PURE__ */ React10.createElement(DialogContent, {
    className: cx8("bg-powder drop-shadow absolute right-0 w-[100vw] h-[100vh] p-4 overflow-auto", sizes3[size]),
    "aria-labelledby": ariaLabelledBy
  }, children));
};
Drawer.displayName = "Drawer";

// src/components/Dropdown.tsx
import * as React11 from "react";
import {
  Menu,
  MenuList,
  MenuButton,
  MenuItem,
  MenuLink
} from "@reach/menu-button";
import cx9 from "classnames";
import { ChevronDown as ChevronDown3 } from "@lunchboxinc/icons";
var Dropdown = ({ label, children, size = "medium" }) => {
  return /* @__PURE__ */ React11.createElement(Menu, null, /* @__PURE__ */ React11.createElement(MenuButton, {
    className: cx9(buttonStyles({ size, variant: "secondary" }), "gap-3")
  }, /* @__PURE__ */ React11.createElement(Typography, null, label), /* @__PURE__ */ React11.createElement(ChevronDown3, {
    className: "w-3 h-3 fill-url"
  })), /* @__PURE__ */ React11.createElement(MenuList, {
    className: "bg-powder shadow-md rounded-md overflow-hidden"
  }, children));
};
Dropdown.displayName = "Dropdown";
var itemClasses = "inline-block w-full px-3 py-2 bg-powder cursor-pointer data-selected:bg-yellow-50 data-selected:hover:bg-gray-100 aria-disabled:cursor-not-allowed aria-disabled:opacity-50 aria-disabled:hover:bg-powder";
var DropdownItem = (props) => {
  return /* @__PURE__ */ React11.createElement(MenuItem, __spreadProps(__spreadValues({}, props), {
    className: itemClasses
  }));
};
DropdownItem.displayName = "DropdownItem";
var DropdownLink = (props) => {
  return /* @__PURE__ */ React11.createElement(MenuLink, __spreadProps(__spreadValues({}, props), {
    className: itemClasses
  }));
};
DropdownLink.displayName = "DropdownLink";

// src/components/Grid.tsx
import * as React12 from "react";
import cx10 from "classnames";
var gridCols = {
  0: "",
  1: "grid-cols-1",
  2: "grid-cols-2",
  3: "grid-cols-3",
  4: "grid-cols-4",
  5: "grid-cols-5",
  6: "grid-cols-6",
  7: "grid-cols-7",
  8: "grid-cols-8",
  9: "grid-cols-9",
  10: "grid-cols-10",
  11: "grid-cols-11",
  12: "grid-cols-12"
};
var gridFlows = {
  none: "",
  col: "grid-flow-col",
  row: "grid-flow-row"
};
var gridRows = {
  0: "",
  1: "grid-rows-1",
  2: "grid-rows-2",
  3: "grid-rows-3",
  4: "grid-rows-4",
  5: "grid-rows-5",
  6: "grid-rows-6"
};
var gaps = {
  0: "gap-0",
  1: "gap-1",
  2: "gap-2",
  3: "gap-3",
  4: "gap-4",
  5: "gap-5",
  6: "gap-6",
  7: "gap-7",
  8: "gap-8",
  9: "gap-9",
  10: "gap-10",
  11: "gap-11",
  12: "gap-12"
};
var xsCols = {
  0: "",
  1: "xs:grid-cols-1",
  2: "xs:grid-cols-2",
  3: "xs:grid-cols-3",
  4: "xs:grid-cols-4",
  5: "xs:grid-cols-5",
  6: "xs:grid-cols-6",
  7: "xs:grid-cols-7",
  8: "xs:grid-cols-8",
  9: "xs:grid-cols-9",
  10: "xs:grid-cols-10",
  11: "xs:grid-cols-11",
  12: "xs:grid-cols-12"
};
var smCols = {
  0: "",
  1: "sm:grid-cols-1",
  2: "sm:grid-cols-2",
  3: "sm:grid-cols-3",
  4: "sm:grid-cols-4",
  5: "sm:grid-cols-5",
  6: "sm:grid-cols-6",
  7: "sm:grid-cols-7",
  8: "sm:grid-cols-8",
  9: "sm:grid-cols-9",
  10: "sm:grid-cols-10",
  11: "sm:grid-cols-11",
  12: "sm:grid-cols-12"
};
var mdCols = {
  0: "",
  1: "md:grid-cols-1",
  2: "md:grid-cols-2",
  3: "md:grid-cols-3",
  4: "md:grid-cols-4",
  5: "md:grid-cols-5",
  6: "md:grid-cols-6",
  7: "md:grid-cols-7",
  8: "md:grid-cols-8",
  9: "md:grid-cols-9",
  10: "md:grid-cols-10",
  11: "md:grid-cols-11",
  12: "md:grid-cols-12"
};
var lgCols = {
  0: "",
  1: "lg:grid-cols-1",
  2: "lg:grid-cols-2",
  3: "lg:grid-cols-3",
  4: "lg:grid-cols-4",
  5: "lg:grid-cols-5",
  6: "lg:grid-cols-6",
  7: "lg:grid-cols-7",
  8: "lg:grid-cols-8",
  9: "lg:grid-cols-9",
  10: "lg:grid-cols-10",
  11: "lg:grid-cols-11",
  12: "lg:grid-cols-12"
};
var Grid = (_a) => {
  var _b = _a, {
    columns = 12,
    rows = 0,
    flow = "none",
    xs = 0,
    sm = 0,
    md = 0,
    lg = 0,
    gap = 0
  } = _b, props = __objRest(_b, [
    "columns",
    "rows",
    "flow",
    "xs",
    "sm",
    "md",
    "lg",
    "gap"
  ]);
  return /* @__PURE__ */ React12.createElement("div", __spreadProps(__spreadValues({}, props), {
    className: cx10(`grid`, gaps[gap], gridFlows[flow], gridCols[columns], gridRows[rows], xsCols[xs], smCols[sm], mdCols[md], lgCols[lg], props.className)
  }), props.children);
};
var colSpans = {
  0: "",
  1: "col-span-1",
  2: "col-span-2",
  3: "col-span-3",
  4: "col-span-4",
  5: "col-span-5",
  6: "col-span-6",
  7: "col-span-7",
  8: "col-span-8",
  9: "col-span-9",
  10: "col-span-10",
  11: "col-span-11",
  12: "col-span-12"
};
var rowSpans = {
  0: "",
  1: "row-span-1",
  2: "row-span-2",
  3: "row-span-3",
  4: "row-span-4",
  5: "row-span-5",
  6: "row-span-6"
};
var alignment = {
  start: "items-start",
  center: "items-center",
  end: "items-end"
};
var justification = {
  around: "justify-around",
  between: "justify-between",
  center: "justify-center",
  end: "justify-end",
  evenly: "justify-evenly",
  start: "justify-start"
};
var Element = (_a) => {
  var _b = _a, {
    alignItems = "start",
    colSpan = 1,
    justifyContent = "start",
    rowSpan = 0,
    wrap = true
  } = _b, props = __objRest(_b, [
    "alignItems",
    "colSpan",
    "justifyContent",
    "rowSpan",
    "wrap"
  ]);
  return /* @__PURE__ */ React12.createElement("div", __spreadProps(__spreadValues({}, props), {
    className: cx10(`flex`, wrap && "flex-wrap", alignment[alignItems], justification[justifyContent], colSpans[colSpan], rowSpans[rowSpan], props.className)
  }));
};
var Col = Element;
var Row = Element;
Grid.displayName = "Grid";

// src/components/Input.tsx
import * as React14 from "react";
import cx12 from "classnames";
import { useId as useId2 } from "@reach/auto-id";
import { VisuallyHidden } from "@reach/visually-hidden";

// src/common/ErrorMessage.tsx
import * as React13 from "react";
import cx11 from "classnames";
import { Warning } from "@lunchboxinc/icons";
var ErrorMessage = ({ message, messageId }) => {
  return /* @__PURE__ */ React13.createElement(Typography, {
    variant: "Caption",
    id: messageId,
    className: cx11("flex items-center gap-2 mt-2 text-red-critical", { hidden: !message })
  }, /* @__PURE__ */ React13.createElement(Warning, {
    fill: "currentColor",
    "aria-label": "Error",
    role: "img",
    className: "w-4 h-4"
  }), message);
};

// src/components/Input.tsx
import { Eye, EyeSlash, TimesCircle } from "@lunchboxinc/icons";
var baseStyles2 = "block w-full p-2 shadow-sm rounded-md border placeholder:text-placeholder";
var Input = (_a) => {
  var _b = _a, {
    label,
    labelVisible = true,
    size = "large",
    type = "text",
    icon: Icon,
    iconPosition = "left",
    errorMessage,
    clearable
  } = _b, props = __objRest(_b, [
    "label",
    "labelVisible",
    "size",
    "type",
    "icon",
    "iconPosition",
    "errorMessage",
    "clearable"
  ]);
  const inputId = useId2(props.id);
  const messageId = useId2();
  const ifIconPosition = !!Icon && iconPosition;
  const isError = !!errorMessage;
  const errorProps = isError ? { "aria-invalid": true, "aria-describedby": messageId } : {};
  const [isPasswordVisible, setIsPasswordVisible] = React14.useState(false);
  const inputRef = React14.useRef(null);
  return /* @__PURE__ */ React14.createElement(React14.Fragment, null, /* @__PURE__ */ React14.createElement("label", {
    htmlFor: inputId,
    className: cx12("block mb-2", { "sr-only": !labelVisible })
  }, /* @__PURE__ */ React14.createElement(Typography, {
    variant: "HeadingSmall"
  }, label)), /* @__PURE__ */ React14.createElement("div", {
    className: "relative"
  }, Icon && /* @__PURE__ */ React14.createElement("div", {
    className: cx12("absolute inset-y-0 flex items-center pointer-events-none", {
      "left-0 pl-2": ifIconPosition === "left",
      "right-0 pr-2": ifIconPosition === "right"
    })
  }, /* @__PURE__ */ React14.createElement(Icon, {
    className: "w-4 h-4",
    "aria-hidden": true,
    focusable: false
  })), type === "password" && /* @__PURE__ */ React14.createElement("div", {
    "aria-live": "polite",
    id: "password-text"
  }, /* @__PURE__ */ React14.createElement(VisuallyHidden, null, isPasswordVisible ? "Password visible" : "Password hidden.")), /* @__PURE__ */ React14.createElement("input", __spreadValues(__spreadProps(__spreadValues({}, props), {
    type: type === "password" && isPasswordVisible ? "text" : type,
    id: inputId,
    className: cx12(baseStyles2, isError ? "border-red-critical" : "border-gray-500", {
      "pl-8": ifIconPosition === "left",
      "pr-8": ifIconPosition === "right",
      "py-1": size === "small"
    }, props.className),
    ref: inputRef
  }), errorProps)), /* @__PURE__ */ React14.createElement("div", {
    className: "absolute inset-y-0 right-0 flex items-center px-2"
  }, type === "password" && /* @__PURE__ */ React14.createElement("button", {
    "aria-checked": isPasswordVisible ? "true" : "false",
    type: "button",
    role: "switch",
    "aria-label": `${isPasswordVisible ? "Hide" : "Show"} password`,
    onClick: () => setIsPasswordVisible(!isPasswordVisible)
  }, isPasswordVisible ? /* @__PURE__ */ React14.createElement(EyeSlash, {
    role: "img",
    className: "w-4 h-4"
  }) : /* @__PURE__ */ React14.createElement(Eye, {
    role: "img",
    className: "w-4 h-4"
  })), clearable && /* @__PURE__ */ React14.createElement("button", {
    "aria-label": "Clear input",
    type: "button",
    className: "ml-2",
    onClick: () => {
      const input = inputRef.current;
      if (input) {
        input.value = "";
      }
    }
  }, /* @__PURE__ */ React14.createElement(TimesCircle, {
    role: "img",
    className: "w-4 h-4"
  })))), /* @__PURE__ */ React14.createElement(ErrorMessage, {
    message: errorMessage,
    messageId
  }));
};
Input.displayName = "Input";
var Textarea = (_a) => {
  var _b = _a, {
    label,
    labelVisible = true,
    onChange,
    maxLength,
    errorMessage,
    disableResize
  } = _b, props = __objRest(_b, [
    "label",
    "labelVisible",
    "onChange",
    "maxLength",
    "errorMessage",
    "disableResize"
  ]);
  const inputId = useId2(props.id);
  const messageId = useId2();
  const [charCount, setCharCount] = React14.useState(0);
  const handleChange = (e) => {
    if (maxLength) {
      const newValue = e.target.value.slice(0, maxLength);
      setCharCount(newValue.length);
      e.target.value = newValue;
    }
    onChange == null ? void 0 : onChange(e);
  };
  const isError = !!errorMessage;
  const errorProps = isError ? { "aria-invalid": true, "aria-describedby": messageId } : {};
  return /* @__PURE__ */ React14.createElement(React14.Fragment, null, /* @__PURE__ */ React14.createElement("label", {
    htmlFor: inputId,
    className: cx12("block mb-2", { "sr-only": !labelVisible })
  }, /* @__PURE__ */ React14.createElement(Typography, {
    variant: "HeadingSmall"
  }, label)), /* @__PURE__ */ React14.createElement("div", {
    className: "relative"
  }, /* @__PURE__ */ React14.createElement("span", {
    className: cx12({ hidden: !maxLength }, "absolute bottom-1 right-2 text-gray-500 text-xs")
  }, charCount, " / ", maxLength), /* @__PURE__ */ React14.createElement("textarea", __spreadValues(__spreadProps(__spreadValues({}, props), {
    id: inputId,
    onChange: handleChange,
    className: cx12(baseStyles2, !errorMessage ? "border-gray-500" : "border-red-critical", { "resize-none": disableResize }, props.className)
  }), errorProps))), /* @__PURE__ */ React14.createElement(ErrorMessage, {
    message: errorMessage,
    messageId
  }));
};
Textarea.displayName = "Textarea";

// src/components/LoadingSpinner.tsx
import * as React15 from "react";
import cx13 from "classnames";
import { Spinner } from "@lunchboxinc/icons";
var loadingSpinnerStyles = "flex flex-col w-fit h-fit items-center justify-center";
var sizes4 = {
  small: "w-4 h-4",
  default: "w-10 h-10"
};
var LoadingSpinner = ({
  spinning = true,
  size = "default",
  tip,
  children
}) => {
  return /* @__PURE__ */ React15.createElement(React15.Fragment, null, /* @__PURE__ */ React15.createElement("div", {
    role: "status",
    className: cx13(loadingSpinnerStyles)
  }, spinning && /* @__PURE__ */ React15.createElement(React15.Fragment, null, /* @__PURE__ */ React15.createElement(Spinner, {
    "aria-label": "Loading",
    className: cx13(sizes4[size], "animate-spin"),
    role: "img",
    focusable: "false"
  }), tip && /* @__PURE__ */ React15.createElement(Typography, null, tip))), children);
};

// src/components/Modal.tsx
import * as React16 from "react";
import { DialogContent as DialogContent2, DialogOverlay as DialogOverlay2 } from "@reach/dialog";
var Modal = (_a) => {
  var _b = _a, {
    children,
    isOpen,
    onDismiss,
    "aria-labelledby": ariaLabelledBy
  } = _b, props = __objRest(_b, [
    "children",
    "isOpen",
    "onDismiss",
    "aria-labelledby"
  ]);
  return /* @__PURE__ */ React16.createElement(DialogOverlay2, __spreadValues({
    className: "fixed flex inset-0 bg-bob/30",
    isOpen,
    onDismiss
  }, props), /* @__PURE__ */ React16.createElement(DialogContent2, {
    className: "rounded-md bg-powder drop-shadow m-auto overflow-auto w-fit max-w-full h-fit",
    "aria-labelledby": ariaLabelledBy
  }, children));
};
Modal.displayName = "Modal";

// src/components/Pagination.tsx
import * as React18 from "react";
import cx14 from "classnames";
import { ChevronLeft, ChevronRight, iconBaseProps as iconBaseProps3 } from "@lunchboxinc/icons";

// src/hooks/usePagination.tsx
import * as React17 from "react";
function range(start, end) {
  const length = end - start + 1;
  return Array.from({ length }, (_, index) => index + start);
}
var usePagination = ({
  totalPages: total,
  onChange,
  initialPage = 1,
  siblings = 1
}) => {
  const boundaries = 1;
  const [activepage, setActivePage] = React17.useState(initialPage);
  const handleChange = (value) => {
    typeof onChange === "function" && onChange(value);
    setActivePage(value);
  };
  const setPage = (pageNumber) => {
    if (pageNumber <= 0) {
      handleChange(1);
    } else if (pageNumber > total) {
      handleChange(total);
    } else {
      handleChange(pageNumber);
    }
  };
  const next = () => setPage(activepage + 1);
  const previous = () => setPage(activepage - 1);
  const pageBoundaryThreshold = 3;
  const paginationRange = React17.useMemo(() => {
    const shouldHideBoundary = pageBoundaryThreshold + siblings * 2 + boundaries * 2 >= total;
    if (shouldHideBoundary) {
      return range(1, total);
    }
    const leftSiblingIndex = Math.max(activepage - siblings, boundaries);
    const rightSiblingIndex = Math.min(activepage + siblings, total - boundaries);
    const shouldShowLeftDots = leftSiblingIndex > boundaries + 2;
    const shouldShowRightDots = rightSiblingIndex < total - (boundaries + 1);
    if (!shouldShowLeftDots && shouldShowRightDots) {
      const leftItemCount = siblings * 2 + boundaries + 2;
      return [...range(1, leftItemCount), "...", ...range(total - (boundaries - 1), total)];
    }
    if (shouldShowLeftDots && !shouldShowRightDots) {
      const rightItemCount = boundaries + 1 + 2 * siblings;
      return [...range(1, boundaries), "...", ...range(total - rightItemCount, total)];
    }
    return [
      ...range(1, boundaries),
      "...",
      ...range(leftSiblingIndex, rightSiblingIndex),
      "...",
      ...range(total - boundaries + 1, total)
    ];
  }, [total, siblings, activepage]);
  return {
    range: paginationRange,
    active: activepage,
    setPage,
    next,
    previous
  };
};

// src/components/Pagination.tsx
var buttonBase = "relative inline-flex items-center px-4 py-2 border text-sm font-medium";
var activeItem = "z-10 bg-url/[0.1] border-url text-url ";
var inactiveItem = "bg-white border-neutral-200 hover:bg-gray-50 ";
var PaginationButton = (_a) => {
  var _b = _a, {
    onClick,
    active,
    direction,
    children
  } = _b, rest = __objRest(_b, [
    "onClick",
    "active",
    "direction",
    "children"
  ]);
  return /* @__PURE__ */ React18.createElement(Button, __spreadProps(__spreadValues({}, rest), {
    role: "link",
    variant: "ghost",
    onClick,
    className: cx14(active ? activeItem : inactiveItem, buttonBase, rest.className, {
      "rounded-l-md": direction === "previous",
      "rounded-r-md": direction === "next",
      "hidden sm:block": !direction,
      "cursor-not-allowed": rest.disabled
    })
  }), children);
};
var Pagination = ({ totalPages, onChange, siblings, initialPage }) => {
  const { range: range2, setPage, next, previous, active } = usePagination({
    totalPages,
    onChange,
    siblings,
    initialPage
  });
  const items = range2.map((pageNumber, index) => /* @__PURE__ */ React18.createElement(PaginationButton, {
    key: index,
    active: pageNumber === active,
    "aria-current": pageNumber === active,
    "aria-disabled": pageNumber === active,
    tabIndex: pageNumber === "..." ? -1 : 0,
    "aria-hidden": pageNumber === "...",
    onClick: () => pageNumber !== "..." ? setPage(pageNumber) : void 0
  }, pageNumber));
  return /* @__PURE__ */ React18.createElement("nav", {
    className: "relative z-0 inline-flex rounded-md shadow-sm -space-x-px",
    "aria-label": "Pagination"
  }, /* @__PURE__ */ React18.createElement(PaginationButton, {
    direction: "previous",
    onClick: previous,
    disabled: active === 1
  }, /* @__PURE__ */ React18.createElement("span", {
    className: "sm:sr-only"
  }, "Previous"), /* @__PURE__ */ React18.createElement(ChevronLeft, __spreadProps(__spreadValues({}, iconBaseProps3), {
    className: "h-3 w-3 hidden sm:block"
  }))), items, /* @__PURE__ */ React18.createElement(PaginationButton, {
    direction: "next",
    onClick: next,
    disabled: active === totalPages
  }, /* @__PURE__ */ React18.createElement("span", {
    className: "sm:sr-only"
  }, "Next"), /* @__PURE__ */ React18.createElement(ChevronRight, __spreadProps(__spreadValues({}, iconBaseProps3), {
    className: "h-3 w-3 hidden sm:block"
  }))));
};
Pagination.displayName = "Pagination";

// src/components/Popover.tsx
import * as React19 from "react";
import { Popover as HeadlessUiPopover } from "@headlessui/react";
import cx15 from "classnames";
var popoverContentStyle = "absolute rounded bg-powder py-2 px-1.5 drop-shadow z-[999999] w-fit after:absolute after:border-4 after:border-solid after:border-transparent";
var topBaseStyles = "bottom-full mb-2.5 after:top-full after:border-t-powder";
var sideBaseStyles = "top-1/2 -translate-y-1/2 after:top-1/2 after:-mt-1";
var Popover = ({ children, content, placement = "bottom" }) => {
  const placements2 = {
    top: `${topBaseStyles} inset-x-1/2 -translate-x-1/2 after:inset-x-1/2 after:-ml-1`,
    topRight: `${topBaseStyles} left-full -ml-5 after:left-0 after:translate-x-2`,
    topLeft: `${topBaseStyles} right-full -mr-5 after:right-0 after:-translate-x-2`,
    right: `${sideBaseStyles} left-full ml-2 after:right-full after:border-r-powder`,
    left: `${sideBaseStyles} right-full mr-2 after:left-full after:border-l-powder`,
    bottom: "inset-x-1/2 top-full -translate-x-1/2 mt-2.5 after:bottom-full after:inset-x-1/2 after:-ml-1 after:border-b-powder"
  };
  return /* @__PURE__ */ React19.createElement(HeadlessUiPopover, {
    className: "relative w-fit"
  }, /* @__PURE__ */ React19.createElement(HeadlessUiPopover.Button, {
    as: "span"
  }, children), /* @__PURE__ */ React19.createElement(HeadlessUiPopover.Panel, {
    className: cx15(placements2[placement], popoverContentStyle)
  }, content));
};

// src/components/QuantitySelector.tsx
import * as React20 from "react";
import { VisuallyHidden as VisuallyHidden2 } from "@reach/visually-hidden";
import cx16 from "classnames";
import { Minus, Plus, iconBaseProps as iconBaseProps4 } from "@lunchboxinc/icons";
var buttonStyle = "rounded-sm w-6  flex  justify-center border-none h-6 hover:bg-neutral-100";
var QuantitySelector = (props) => {
  const { size = "large", name, disabled, decrement, increment, quantity } = props;
  return /* @__PURE__ */ React20.createElement("div", {
    className: cx16("border-2 w-24 h-10 flex border-neutral-200 rounded-md flex-row justify-around items-center p-2", {
      "p-1 h-8": size === "small",
      "cursor-not-allowed bg-neutral-100 text-neutral-700": disabled
    })
  }, /* @__PURE__ */ React20.createElement(Button, {
    role: "button",
    "aria-disabled": quantity <= 0 || disabled,
    variant: "ghost",
    "aria-label": `Decrease ${name} quantity`,
    "aria-hidden": "true",
    className: cx16(quantity <= 0 ? "text-neutral-200" : "text-neutral-900", buttonStyle, {
      "pointer-events-none cursor-not-allowed": disabled,
      "hover:bg-white": quantity <= 0
    }),
    onClick: decrement,
    disabled: disabled || quantity <= 0
  }, /* @__PURE__ */ React20.createElement(Minus, __spreadValues({
    className: "w-4 h-4 p-1"
  }, iconBaseProps4))), /* @__PURE__ */ React20.createElement("div", {
    "aria-live": "polite"
  }, /* @__PURE__ */ React20.createElement(VisuallyHidden2, null, name, " quantity: "), /* @__PURE__ */ React20.createElement(Typography, {
    variant: "Body",
    className: cx16(disabled ? "text-neutral-200" : "text-neutral-900")
  }, quantity)), /* @__PURE__ */ React20.createElement(Button, {
    role: "button",
    variant: "ghost",
    "aria-disabled": disabled,
    "aria-label": `Increment ${name} quantity`,
    "aria-hidden": "true",
    className: cx16(disabled ? "text-neutral-200" : "text-neutral-900", buttonStyle, {
      "pointer-events-none cursor-not-allowed": disabled
    }),
    onClick: increment,
    disabled
  }, /* @__PURE__ */ React20.createElement(Plus, __spreadValues({
    className: "w-4 h-4 p-1"
  }, iconBaseProps4))));
};
QuantitySelector.displayName = "QuantitySelector";

// src/components/RadioGroup.tsx
import * as React21 from "react";
import cx17 from "classnames";
import { useId as useId3 } from "@reach/auto-id";
import { useGarnish as useGarnish2 } from "@lunchboxinc/garnish";
var radioStyles = "h-6 aria-disabled:cursor-not-allowed aria-disabled:opacity-75";
var Radio = (_a) => {
  var _b = _a, { id, value, label = value, description = "", disabled } = _b, props = __objRest(_b, ["id", "value", "label", "description", "disabled"]);
  const inputId = useId3(id);
  const descriptionId = useId3();
  return /* @__PURE__ */ React21.createElement("div", {
    className: "flex items-start gap-2"
  }, /* @__PURE__ */ React21.createElement("input", __spreadProps(__spreadValues({}, props), {
    id: inputId,
    type: "radio",
    value,
    className: cx17(radioStyles, props.className),
    "aria-describedby": description ? descriptionId : void 0,
    "aria-disabled": disabled
  })), /* @__PURE__ */ React21.createElement(Typography, {
    className: cx17({ "text-neutral-700": disabled })
  }, /* @__PURE__ */ React21.createElement("label", {
    htmlFor: inputId
  }, label), description && /* @__PURE__ */ React21.createElement(Typography, {
    id: descriptionId,
    component: "p",
    variant: "Caption",
    className: "text-neutral-700"
  }, description)));
};
Radio.displayName = "Radio";
var layoutStyles = {
  horizontal: "flex-row gap-6",
  vertical: "flex-col gap-3"
};
var RadioGroup = (_a) => {
  var _b = _a, {
    options,
    onChange,
    name,
    defaultValue,
    disabled,
    className,
    layout = "vertical"
  } = _b, props = __objRest(_b, [
    "options",
    "onChange",
    "name",
    "defaultValue",
    "disabled",
    "className",
    "layout"
  ]);
  const themeStyles = useGarnish2({ accent: "accent-url" });
  const [selectedRadio, setSelectedRadio] = React21.useState(defaultValue);
  const handleChange = (e) => {
    if (!disabled) {
      const { value } = e.target;
      setSelectedRadio(value);
      onChange(value);
    }
  };
  return /* @__PURE__ */ React21.createElement("div", __spreadValues({
    className: cx17("flex", layoutStyles[layout], className),
    role: "radiogroup"
  }, props), options.map((option) => {
    const { value } = option;
    return /* @__PURE__ */ React21.createElement(Radio, __spreadProps(__spreadValues({}, option), {
      key: value,
      id: `${name || "radio"}-${value}`,
      checked: value === selectedRadio,
      onChange: handleChange,
      name,
      disabled,
      className: themeStyles.accent
    }));
  }));
};
RadioGroup.displayName = "RadioGroup";

// src/components/Select.tsx
import * as React22 from "react";
import { Listbox } from "@headlessui/react";
import cx18 from "classnames";
import { useId as useId4 } from "@reach/auto-id";
import { Check as Check2, ChevronDown as ChevronDown4, iconBaseProps as iconBaseProps5 } from "@lunchboxinc/icons";
var Select = (_a) => {
  var _b = _a, {
    label,
    options,
    labelVisible = true,
    onChange,
    defaultOption = 0,
    variant = "default",
    size = "medium",
    disabled,
    errorMessage,
    name
  } = _b, props = __objRest(_b, [
    "label",
    "options",
    "labelVisible",
    "onChange",
    "defaultOption",
    "variant",
    "size",
    "disabled",
    "errorMessage",
    "name"
  ]);
  const id = useId4(props.id);
  const [selected, setSelected] = React22.useState(options[defaultOption]);
  const isError = !!errorMessage;
  const errorProps = isError ? { "aria-invalid": true, "aria-describedby": id } : {};
  const handleChange = React22.useCallback((option) => {
    setSelected(option);
    onChange == null ? void 0 : onChange(option);
  }, [onChange]);
  const variantStyle = variant === "default" ? "secondary" : "tertiary";
  return /* @__PURE__ */ React22.createElement(React22.Fragment, null, /* @__PURE__ */ React22.createElement(Listbox, {
    value: selected,
    onChange: handleChange,
    name,
    disabled
  }, /* @__PURE__ */ React22.createElement(Listbox.Label, {
    id,
    className: cx18("block mb-1", { "sr-only": !labelVisible })
  }, /* @__PURE__ */ React22.createElement(Typography, {
    variant: "HeadingSmall"
  }, label)), /* @__PURE__ */ React22.createElement("div", {
    className: "relative"
  }, /* @__PURE__ */ React22.createElement(Listbox.Button, {
    "aria-labelledby": id,
    className: cx18("flex justify-between w-full", buttonStyles({ variant: variantStyle, size, disabled }), isError && "border-red-critical", __spreadValues({}, errorProps))
  }, /* @__PURE__ */ React22.createElement(Typography, null, (selected == null ? void 0 : selected.label) || (selected == null ? void 0 : selected.value)), /* @__PURE__ */ React22.createElement(ChevronDown4, __spreadProps(__spreadValues({}, iconBaseProps5), {
    className: "h-4 w-4"
  }))), /* @__PURE__ */ React22.createElement(Listbox.Options, {
    "aria-disabled": disabled,
    className: "absolute z-10 mt-1 w-full bg-white shadow-lg max-h-60 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm"
  }, options.map((option) => {
    const { value, label: label2 = value, disabled: disabled2 } = option;
    return /* @__PURE__ */ React22.createElement(Listbox.Option, {
      key: value,
      value: option,
      className: ({ active }) => cx18("relative cursor-default select-none py-2 pr-8 pl-3 bg-powder hover:bg-gray-100 aria-disabled:cursor-not-allowed aria-disabled:opacity-50 aria-disabled:hover:bg-powder", { "bg-yellow-50": active }),
      disabled: disabled2
    }, ({ selected: selected2 }) => /* @__PURE__ */ React22.createElement(React22.Fragment, null, /* @__PURE__ */ React22.createElement(Typography, {
      className: "block truncate"
    }, label2), /* @__PURE__ */ React22.createElement(Check2, __spreadProps(__spreadValues({}, iconBaseProps5), {
      className: cx18("absolute top-1/2 right-3 transform -translate-y-1/2 flex items-center h-4 w-auto", { hidden: !selected2 })
    }))));
  })))), /* @__PURE__ */ React22.createElement(ErrorMessage, {
    message: errorMessage,
    messageId: id
  }));
};
Select.displayName = "Select";

// src/components/Switch.tsx
import * as React23 from "react";
import cx19 from "classnames";
import { useId as useId5 } from "@reach/auto-id";
var Switch = (_a) => {
  var _b = _a, {
    label,
    labelVisible = true,
    enabled,
    onChange,
    "aria-labelledby": ariaLabelledby,
    disabled
  } = _b, props = __objRest(_b, [
    "label",
    "labelVisible",
    "enabled",
    "onChange",
    "aria-labelledby",
    "disabled"
  ]);
  const labelId = useId5(ariaLabelledby);
  const handleChange = () => {
    if (!disabled) {
      onChange(!enabled);
    }
  };
  return /* @__PURE__ */ React23.createElement("div", {
    className: "inline-flex items-center gap-4"
  }, /* @__PURE__ */ React23.createElement("button", __spreadProps(__spreadValues({}, props), {
    type: "button",
    role: "switch",
    "aria-labelledby": labelId,
    "aria-checked": enabled,
    onClick: handleChange,
    "aria-disabled": disabled,
    className: cx19(enabled ? "bg-url" : "bg-neutral-500", "relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200", "focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-blue-500", "aria-disabled:bg-neutral-400 aria-disabled:cursor-not-allowed", props.className)
  }), /* @__PURE__ */ React23.createElement("span", {
    "aria-hidden": "true",
    className: cx19(enabled ? "translate-x-5" : "translate-x-0", "pointer-events-none inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200")
  })), !ariaLabelledby && /* @__PURE__ */ React23.createElement("label", {
    id: labelId,
    className: cx19({ "sr-only": !labelVisible })
  }, label));
};
Switch.displayName = "Switch";

// src/components/Tabs.tsx
import * as React24 from "react";
import cx20 from "classnames";
import {
  Tabs as ReachTabs,
  TabList as ReachTabList,
  Tab as ReachTab,
  TabPanels,
  TabPanel
} from "@reach/tabs";
var Tabs = (props) => /* @__PURE__ */ React24.createElement(ReachTabs, __spreadValues({}, props));
var pxPadding = {
  0: "px-0",
  1: "px-1",
  2: "px-2",
  3: "px-3",
  4: "px-4",
  5: "px-5",
  6: "px-6",
  7: "px-7",
  8: "px-8",
  9: "px-9",
  10: "px-10",
  11: "px-11",
  12: "px-12"
};
var TabList = (_a) => {
  var _b = _a, { padding = 0, className } = _b, props = __objRest(_b, ["padding", "className"]);
  return /* @__PURE__ */ React24.createElement(ReachTabList, __spreadProps(__spreadValues({}, props), {
    className: cx20("flex gap-4", className, pxPadding[padding])
  }));
};
var Tab = (_a) => {
  var _b = _a, { children } = _b, props = __objRest(_b, ["children"]);
  return /* @__PURE__ */ React24.createElement(ReachTab, __spreadProps(__spreadValues({}, props), {
    className: cx20("py-2 border-b-4 border-transparent text-neutral-600 data-selected:text-inherit data-selected:border-url focus-visible:z-10", props.className)
  }), /* @__PURE__ */ React24.createElement(Typography, null, children));
};
Tabs.displayName = "Tabs";
TabList.displayName = "TabList";
Tab.displayName = "Tab";
TabPanels.displayName = "TabPanels";
TabPanel.displayName = "TabPanel";

// src/components/Tag.tsx
import * as React25 from "react";
import cx21 from "classnames";
import { CheckCircle, TimesCircle as TimesCircle2 } from "@lunchboxinc/icons";
var colors = {
  gray: "border-neutral-500 bg-neutral-50",
  green: "border-emerald-700 bg-emerald-50",
  red: "border-red-600 bg-red-100",
  blue: "border-teal-700 bg-teal-50",
  gold: "border-yellow-900 bg-yellow-50"
};
var fillColors2 = {
  gray: "fill-neutral-500",
  green: "fill-emerald-700",
  red: "fill-red-600",
  blue: "fill-teal-700",
  gold: "fill-yellow-900"
};
var tagStyles = "text-neutral-800 flex items-center w-fit px-2 py-0.5 rounded-sm border-solid border";
var icons = {
  success: CheckCircle,
  error: TimesCircle2
};
var Tag = ({ label, color = "gray", icon }) => {
  const Icon = icon ? icons[icon] : null;
  return /* @__PURE__ */ React25.createElement(Typography, {
    component: "div",
    variant: "Subheading",
    className: cx21(tagStyles, colors[color])
  }, Icon && /* @__PURE__ */ React25.createElement(Icon, {
    role: "img",
    "aria-label": icon,
    focusable: "false",
    className: cx21("mr-1", fillColors2[color]),
    height: "1em"
  }), label);
};
Tag.displayName = "Tag";

// src/components/Tooltip.tsx
import * as React26 from "react";
import cx22 from "classnames";
import { useTooltip } from "@reach/tooltip";
var tooltipPopupStyle = "absolute font-normal text-sm text-center normal-case text-white whitespace-normal min-h-10 w-max py-2 px-1.5 bg-black rounded bg-opacity-75 drop-shadow z-[999999] after:absolute after:border-4 after:border-solid after:border-transparent";
var topBaseStyles2 = "bottom-full mb-2.5 after:top-full after:border-t-black";
var sideBaseStyles2 = "top-1/2 -translate-y-1/2 after:top-1/2 after:-mt-1";
var placements = {
  top: `${topBaseStyles2} inset-x-1/2 -translate-x-1/2 after:inset-x-1/2 after:-ml-1`,
  topRight: `${topBaseStyles2} left-full -ml-5 after:left-0 after:translate-x-2`,
  topLeft: `${topBaseStyles2} right-full -mr-5 after:right-0 after:-translate-x-2`,
  right: `${sideBaseStyles2} left-full ml-2 after:right-full after:border-r-black`,
  left: `${sideBaseStyles2} right-full mr-2 after:left-full after:border-l-black`,
  bottom: "top-full inset-x-1/2 -translate-x-1/2 mt-2.5 after:bottom-full after:inset-x-1/2 after:-ml-1 after:border-b-black"
};
var sizes5 = {
  default: "max-w-[50vw] md:max-w-xl",
  xs: "max-w-xs",
  sm: "max-w-sm",
  md: "max-w-md",
  lg: "max-w-lg"
};
var Tooltip = ({
  children,
  popupLabel,
  placement = "right",
  size = "default"
}) => {
  const [trigger, tooltip] = useTooltip();
  const { isVisible } = tooltip;
  return /* @__PURE__ */ React26.createElement("span", {
    className: "relative inline-block"
  }, React26.cloneElement(children, trigger), isVisible && /* @__PURE__ */ React26.createElement("span", {
    role: "tooltip",
    className: cx22(tooltipPopupStyle, placements[placement], sizes5[size])
  }, popupLabel));
};
export {
  Accordion,
  Alert,
  Breadcrumb,
  Button,
  ButtonGroup,
  Checkbox,
  Col,
  ComboBox,
  Divider,
  Drawer,
  Dropdown,
  DropdownItem,
  DropdownLink,
  Grid,
  IconButton,
  Input,
  LoadingSpinner,
  Modal,
  Pagination,
  Popover,
  QuantitySelector,
  RadioGroup,
  Row,
  Select,
  Switch,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Tag,
  Textarea,
  Tooltip,
  Typography,
  buttonStyles
};
